import FeatureController from '../FeatureController';

export default class NotificationsController extends FeatureController{

    constructor(panel, $state) {
        super(panel, $state);
        this.endpoint = '/v1/notifications';
        this.filter = 'all';
        this.filterActivity();
    }

    filterActivity () {
        const self = this;
        let filter = this.filter === 'all' ? '' : '?filter='+this.filter;
        this.panel.get(this.endpoint+filter, (response) => {
            if (self.panel.okay(response)) {
                self.activity_types = response.activity_types;
                self.activity_types.unshift({'name':'all', 'config_name':'Show All'});
                // console.log(self.activity_types);
                self.feed = response.feed;
                self.filter = response.filter;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/features/notifications/NotificationsController.js